import React from "react";
import { motion } from "framer-motion";
import { MapPin, Beaker, Hand, Star, Award, Wrench } from "lucide-react";
import { STUDIO_ADDRESS } from "../lib/services";
import { useSiteContent } from "../contexts/SiteContentContext";

const BOX_ICONS = [Beaker, Hand, Star, Award, Wrench];

export default function About() {
  const { text } = useSiteContent();
  const about = text.about_section || {};
  const name = about.name || "David Červený";
  const role = about.role || "Founder · Apex Detailing";
  const intro =
    about.intro ||
    "Apex detailing vznikl z vášně k automobilům a důrazu na kvalitu — bez kompromisů. Pracuji ručně, zaměřuji se na detail a každé auto vám vrátím s pocitem, jako byste si ho právě vyzvedli ze salonu.";
  const extraBoxes = Array.isArray(about.boxes) ? about.boxes : [];

  const boxes = [
    { icon: MapPin, title: "Lokalita", value: STUDIO_ADDRESS.full, mobileValue: STUDIO_ADDRESS.full.replace("250 91 ", "") },
    ...extraBoxes.map((b, i) => ({ icon: BOX_ICONS[i % BOX_ICONS.length], title: b.title, value: b.value })),
  ];

  return (
    <section id="o-mne" className="relative py-24 md:py-32 tone-about overflow-hidden" data-testid="about-section">
      <div className="lit-about-light absolute inset-0 pointer-events-none" />
      <div className="relative max-w-[1180px] mx-auto px-[22px] md:px-8 grid lg:grid-cols-[420px_1fr] gap-12 lg:gap-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: false }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <span className="eyebrow text-akcent" data-testid="about-eyebrow">O mně</span>
          <h2 className="t-h1 mt-4 text-krem-100" data-testid="about-name">
            {name.split(" ")[0]} <span style={{ color: "var(--krem-100)" }}>{name.split(" ").slice(1).join(" ") || ""}</span>
          </h2>
          <p className="mt-2 t-label text-tlum-dark" style={{ fontSize: "17.25px" }} data-testid="about-role">{role}</p>
          <p className="t-body mt-6 text-tlum-dark" data-testid="about-intro">{intro}</p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-5 content-start">
          {boxes.map((b, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: false }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: "easeOut" }}
              className="rounded-2xl card-dark p-[19px]"
              data-testid={`about-box-${i}`}
            >
              <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4 text-akcent" style={{ background: "rgba(201,166,107,0.16)" }}>
                <b.icon className="w-5 h-5" />
              </div>
              <div className="t-label text-tlum-dark" style={{ fontSize: "13.5px" }}>{b.title}</div>
              <div className="mt-1.5 about-box-value text-krem-100">
                {b.mobileValue ? (
                  <>
                    <span className="hidden md:inline">{b.value}</span>
                    <span className="md:hidden">{b.mobileValue}</span>
                  </>
                ) : b.value}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
